import PropTypes from 'prop-types';
import { getFieldContents } from '../utils';
import PartName from '../PartName';
import NoteItem from '../NoteItem';
import style from '../styles.module.scss';

const Notes = ({ partList, key }) => {
  return (
    <>
      {partList.map(item => (
        <div className="my-2 pe-3" key={key}>
          <div className={style['partname__number-container']}>
            <PartName item={item} />
            <div className="ps-2">
              {getFieldContents(item)?.map(value => (
                <div key={key}>
                  <NoteItem {...value} />
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </>
  );
};
Notes.propTypes = {
  partList: PropTypes.arrayOf(
    PropTypes.shape({
      partNumber: PropTypes.string,
      partName: PropTypes.string,
      quantity: PropTypes.string,
      isPartNumberDisplay: PropTypes.bool,
      lineItemNotes: PropTypes.shape({})
    })
  ),
  key: PropTypes.string
};
export default Notes;
